import { Outlet } from 'react-router-dom';
import LeftRail from './LeftRail';
import TopBar from './TopBar';
import { PageFooter } from './PageFooter';
import { BottomNav } from '@/components/mobile/BottomNav';
import { useCanonicalTag } from '@/hooks/useCanonicalTag';
import { useIsMobile } from '@/hooks/use-mobile';
import { ReconnectingBanner } from '@/components/ui/ReconnectingBanner';

const AppShell = () => {
  // Inject canonical tags for each route
  useCanonicalTag();
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-background">
      <ReconnectingBanner />

      {/* Hide LeftRail on mobile */}
      {!isMobile && <LeftRail />}
      <TopBar />

      {/* Main Content Area - no left padding on mobile */}
      <main
        className={`min-h-screen flex flex-col ${isMobile ? 'pb-bottom-nav' : 'pl-52'}`}
        style={{ paddingTop: '56px' }}
      >
        <div className="flex-1">
          <Outlet />
        </div>
        {/* Footer only on desktop - mobile has legal info in drawer */}
        {!isMobile && <PageFooter />}
      </main>

      {/* Mobile Bottom Navigation */}
      {isMobile && <BottomNav />}
    </div>
  );
};

export default AppShell;
